module.exports = __webpack_public_path__ + "img/request.854d46ed.png";